import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddReservationCompanionEmails1787244000000 implements MigrationInterface {
	name = 'AddReservationCompanionEmails1787244000000'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" ADD "companionEmails" text`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "reservation" DROP COLUMN "companionEmails"`)
	}
}
